import initFullpage from "./components/fullpage"
import initCvSection from "./components/cv-section"
import "./components/download"

initFullpage()
initCvSection()